import { Pipe, PipeTransform } from "@angular/core";
import moment, { unitOfTime } from "moment";

/**
 * Pipe to format a duration  to a human readable format.
 */
@Pipe({
    name: 'shortDuration',
    standalone: false
})
export class ShortDurationPipe implements PipeTransform {
    transform(value: number,unit:unitOfTime.DurationConstructor="seconds",includeNegatives=false):string {
        const fmtValue = includeNegatives ? value : Math.abs(value)
        const duration = moment.duration(fmtValue, unit)
        const days = Math.trunc(duration.asDays())
        const hours = duration.hours()
        const minutes = duration.minutes()
        const seconds = duration.seconds()
        if (!days && !hours && !minutes && !seconds) return '0s'
        return `${days ? days + 'd' : ''} ${hours ? hours + 'h' : ''} ${minutes ? minutes + 'm' : ''} ${seconds ? seconds  + 's' : '' }`
    }

}